/* Cache Storage names shared by the Service Worker (src/sw.ts) and the main-thread
 * runtime-cache manager (src/runtime/runtime-cache.ts). Kept in one tiny module so
 * the prefetch/manager and the SW address the SAME caches — a mismatch would make
 * the manager unable to see/remove what the SW stored (and vice-versa).
 *
 * - SHELL_CACHE is versioned (bumped on each deploy): holds the navigation fallback
 *   so the activate step can drop stale shells. Bump SHELL_VERSION when the app
 *   shell HTML changes in a way that must invalidate offline copies.
 * - ASSET_CACHE holds content-hashed /assets/* (immutable filenames → safe across
 *   deploys; new hashes simply add entries).
 * - WASM_CACHE is stable: /wasm/* binaries are addressed by version directory and
 *   are immutable, so they survive deploys and are managed explicitly by the user
 *   via the Settings cache manager. */

export const SHELL_VERSION = 'v3';
export const SHELL_CACHE = `php-shell-${SHELL_VERSION}`;
export const ASSET_CACHE = 'php-assets';
export const WASM_CACHE = 'php-wasm-runtime';

/** Caches the SW owns — anything not in this set is pruned on activate. */
export const OWNED_CACHES = [SHELL_CACHE, ASSET_CACHE, WASM_CACHE];
